import {
  makeStyles,
  tokens,
} from '@fluentui/react-components';

// taken from login-mkt/constants.less
const screenSmall = '768px';
const screenMedium = '978px';

export const useIdpCenteredSelectionPageStyles = makeStyles({
  idpSelectionPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    minHeight: '100vh',
    height: 'auto',
    backgroundImage: 'radial-gradient(at 2.7% 92.9%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 100.2% 77.6%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 1.3% 13.0%, #f0f3f5 0px, transparent 50%),radial-gradient(at 55.5% 13.8%, #fcf9f5 0px, transparent 50%),radial-gradient(at 55.7% 72.1%, #ffffff 0px, transparent 50%),radial-gradient(at 96.0% 12.2%, hsl(200, 35%, 93%) 0px, transparent 50%)',
    [`@media (max-width: ${screenSmall})`]: {
      backgroundImage: 'none',
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 'auto',
    [`@media (max-width: ${screenSmall})`]: {
      margin: '0',
      width: '100%',
    },
  },
  section: {
    display: 'flex',
    marginTop: tokens.spacingVerticalS,
    marginBottom: tokens.spacingVerticalS,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusXLarge,
    boxShadow: tokens.shadow8,
    [`@media (max-width: ${screenSmall})`]: {
      boxShadow: 'none',
      width: '100%',
    },
  },
  sectionAdditionalInfo: {
    display: 'block',
    textAlign: 'center',
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalL,
  },
  contentLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '404px',
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXXL,
    paddingLeft: tokens.spacingHorizontalXXXL,
    paddingRight: tokens.spacingHorizontalXXXL,
    [`@media (max-width: ${screenSmall})`]: {
      width: '100%',
      boxSizing: 'border-box',
      paddingBottom: '0',
      paddingLeft: tokens.spacingHorizontalL,
      paddingRight: tokens.spacingHorizontalL,
    },
  },
  textAndButtons: {
    margin: 'auto',
    width: '100%',
  },
  idpSelectionPageTitle: {
    marginTop: tokens.spacingVerticalL,
    marginBottom: tokens.spacingVerticalS,
  },
  buttonsFooter: {
    color: tokens.colorNeutralForeground3,
    textAlign: 'center',
  },
  termsAndConditionsLink: {
    textDecoration: 'underline',
  },
  buttons: {
    marginTop: tokens.spacingVerticalXXL,
    marginBottom: tokens.spacingVerticalXXL,
  },
  contentRight: {
    lineHeight: '1',
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    [`@media (max-width: ${screenMedium})`]: {
      display: 'none',
    },
  },
});
